// extracted by mini-css-extract-plugin
module.exports = {"bannerWrap":"TourBanner_bannerWrap__3DhjS"};